export default {
  'app.analysis.test': '工專路 {no} 號店',
  'app.analysis.introduce': '指標說明',
  'app.analysis.total-sales': '總銷售額',
  'app.analysis.day-sales': '日銷售額',
  'app.analysis.visits': '訪問量',
  'app.analysis.visits-trend': '訪問量趨勢',
  'app.analysis.visits-ranking': '門店訪問量排名',
  'app.analysis.day-visits': '日訪問量',
  'app.analysis.week': '周同比',
  'app.analysis.day': '日同比',
  'app.analysis.payments': '支付筆數',
  'app.analysis.conversion-rate': '轉化率',
  'app.analysis.operational-effect': '運營活動效果',
  'app.analysis.sales-trend': '銷售趨勢',
  'app.analysis.sales-ranking': '門店銷售額排名',
  'app.analysis.all-year': '全年',
  'app.analysis.all-month': '本月',
  'app.analysis.all-week': '本周',
  'app.analysis.all-day': '今日',
  'app.analysis.search-users': '搜索用戶數',
  'app.analysis.per-capita-search': '人均搜索次數',
  'app.analysis.online-top-search': '線上熱門搜索',
  'app.analysis.the-proportion-of-sales': '銷售額類別占比',
  'app.analysis.channel.all': '全部渠道',
  'app.analysis.channel.online': '線上',
  'app.analysis.channel.stores': '門店',
  'app.analysis.sales': '銷售額',
  'app.analysis.traffic': '客流量',
  'app.analysis.table.rank': '排名',
  'app.analysis.table.search-keyword': '搜索關鍵詞',
  'app.analysis.table.users': '用戶數',
  'app.analysis.table.weekly-range': '周漲幅',
};
